import React from "react";
import { graphql, useStaticQuery } from "gatsby";

export const useProductCategories = () => {
  const { allWpProductCategory } = useStaticQuery(graphql`
    query {
      allWpProductCategory {
        nodes {
          slug
          products {
            nodes {
              productData {
                productMeta {
                  stackStatus
                  buyPrice {
                    price
                  }
                  hirePrice {
                    price
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return allWpProductCategory.nodes
}
